import React from 'react'
import { Table } from 'react-bootstrap'
import { connect } from 'react-redux'

import QuickFitDashboardCard from '../QuickFitDashboardCard'
import QuickFitDashboardTitle from '../QuickFitDashboardTitle'
import QuickFitDashboardItemCounter from '../QuickFitDashboardItemCounter'
import BikeRow from './BikeRow'
import BikesFooter from './BikesFooter'

import useNextPrevious from '../../hooks/action-hooks/useNextPrevious'

import useCustomerBikes from '../../hooks/data-fetch-hooks/useCustomerBikes'

import { usShort } from '../../../utils/dateFormats'

const CustomerBikes = ({
  customerId,
  firstName,
  lastName,
  bikes: { customerBikes }
}) => {
  const bikesLoaded = useCustomerBikes(customerId)

  const displayCount = 5

  const nextPrevious = useNextPrevious(displayCount, customerBikes.length)

  const { start, stop, length } = nextPrevious

  if (customerBikes.length !== length) {
    nextPrevious.setcurrentLength(customerBikes.length)
  }
  if (bikesLoaded && stop > customerBikes.length)
    nextPrevious.setStop(customerBikes.length)

  return (
    <>
      <QuickFitDashboardCard
        style={{ minHeight: '392px' }}
        title={
          <>
            <QuickFitDashboardTitle title='Bikes' />
            <QuickFitDashboardItemCounter
              start={start}
              stop={stop}
              length={length}
            />
          </>
        }
        footer={
          <>
            <BikesFooter
              nextPrevious={nextPrevious}
              customerId={customerId}
              firstName={firstName}
              lastName={lastName}
            />
          </>
        }
      >
        {customerBikes.length === 0 ? (
          <p>No Bikes Found</p>
        ) : (
          <Table size='sm' style={{ fontSize: '.8rem' }}>
            <tbody>
              {customerBikes.slice(start - 1, stop).map((bike) => {
                return (
                  <BikeRow
                    key={bike._id}
                    {...bike}
                    updated={usShort(bike.updated)}
                    bikeTableMode={false}
                  />
                )
              })}
            </tbody>
          </Table>
        )}
      </QuickFitDashboardCard>
    </>
  )
}

const mapStateToProps = (state) => ({
  prefitinterviews: state.prefitinterviews,
  bikes: state.bikes
})

export default connect(mapStateToProps, {})(CustomerBikes)
